var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerpoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-178 375.1 53.8 46",
    style: {
      enableBackground: "new -178 375.1 53.8 46"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DC5B26;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-144.3,386.1v5.6h5.6C-138.7,388.6-141.2,386.1-144.3,386.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-158.1,391.8c-0.6-0.3-1.1-0.2-1.7-0.1c-0.3,0.1-0.2,0.3-0.2,0.5c0,0.5,0,1,0,1.4c0,0.7,0,1.5,0,2.2 c0.6,0.1,1,0.2,1.6,0.1c0.9-0.3,1.2-1.1,1.3-2C-157.1,393.1-157.2,392.2-158.1,391.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-133.1,382h-14.7v-4.6l-22.4,3.9v30.4l22.4,3.9v-5.1h14.8c0.6,0,1-0.5,1-1v-26.4 C-132.1,382.5-132.5,382-133.1,382z M-154.4,394.8c-0.3,1.5-1.2,2.8-2.6,3.4c-1,0.4-1.9,0.3-2.9,0.2c0,1.7,0,3.4,0,5.1 c-0.7-0.1-1.3-0.1-1.9-0.2c-0.2-0.1-0.7,0-0.7-0.2c0-1,0-2,0-3c0-3.1,0-6.2,0-9.2c0-0.4,0-0.8,0-1.2c0-0.3-0.1-0.3,0.2-0.3 c1.3-0.1,2.5-0.2,3.7-0.2c1.4,0,2.7,0.2,3.6,1.4C-154.3,391.7-154.2,393.4-154.4,394.8z M-133.3,409.3h-14.5v-3.1h10.7v-1.8h-10.7 v-2.3h10.7v-1.7h-10.7v-2.6c0.8,0.4,1.6,0.6,2.5,0.6c3.1,0,5.6-2.5,5.6-5.6h-5.6v-5.7c-0.9,0-1.8,0.2-2.5,0.6v-4.4h14.5V409.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerpoint);
export default __webpack_public_path__ + "static/media/powerpoint.67205821cbfb19d12e152d286664125d.svg";
export { ForwardRef as ReactComponent };